import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '@common/services/AuthService/AuthService';

@Component({
  templateUrl: './microsoftLoginView.component.html',
  styleUrls: ['./microsoftLoginView.component.scss'],
})
export class MicrosoftLoginViewComponent implements OnInit {
  code: string;

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.route
      .queryParams
      .subscribe((params) => {
        this.authService.microsoftLogin(params['code']);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/auth/views/microsoftLoginView/microsoftLoginView.component.ts